// extracted by mini-css-extract-plugin
export var basicSlideCard = "basicSlideCard-module--basic-slide-card--5fffa";
export var image = "basicSlideCard-module--image--bd195";